<template>
    <div>
        <div class="content">
            <img src="../assets/service-support.png" class="img-fluid" alt="Responsive image">
            <div v-if="path === '/DownLoad'" class="banner-download">
                <div class="banner-download-text">根据您的运营需求，选择适合的版本</div>
                <router-link to="/Different" class="banner-download-btn">查看软件对比</router-link>
            </div>
            <div v-else class="content-title">
                <div class="content-detail">服务支持</div>
                <div class="en">
                    <hr><span>Service Support</span>
                    <hr>
                </div>
            </div>
        </div>
            <!-- 登录界面 -->
    <div class="login_box" v-if="path === '/ServiceSupport'">
      <Login></Login>
    </div>
        <router-view />
    </div>
</template>
<script>
import Login from "./Login/Login"
export default {
    name: "serviceSupport",
    components: { Login },
    data() {
        return {
        };
    },
    computed: {
        path() {
            return this.$route.path
        }
    },
    methods: {
    }
};
</script>
<style lang="css" scoped>
.login_box {
  z-index: 999;
  position: absolute;
  right: 10%;
  top: 10vh;
  width: 16%;
  height: 28.8vh;
  min-width: 240px;
  min-height: 284px;
  border-radius: 10px;
  overflow: hidden;
}
.content {
    overflow: hidden;
    width: 100%;
    position: relative;
}

.content-title {
    position: absolute;
    top: 178px;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
}

.content-detail {
    width: 480px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 2px solid #fff;
    border-top: 0;
    font-size: 45px;
    color: #fff;
    position: relative;
}

.en {
    width: 100%;
    text-align: center;
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
}

.en hr {
    display: inline-block;
    width: 140px;
    height: 1px;
    margin-top: 12px;
    background-color: #fff;
}

.en span {
    display: inline-block;
    width: 193px;
    text-align: center;
    font-size: 18px;
    color: #fff;
    vertical-align: top;
}
.banner-download {
    position: absolute;
    top: 178px;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
}
.banner-download-text {
    font-size: 54px;
    color: #fff;
    text-align: center;
}
.banner-download-btn {
    width: 200px;
    height: 52px;
    line-height: 52px;
    font-size: 18px;
    color: #fff;
    text-align: center;
    background-color: #0090F3;
    border-radius: 999px;
    text-decoration: none;
    display: inline-block;
    margin-top: 20px;
    margin-left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
}
.banner-download-btn:hover {
    color: #333;
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ServiceSupport.vue